import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';

const buttonStyles = {
  color: (props) => ({
    backgroundColor: props.color,
    borderColor: props.color,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.color}`,
      color: props.color,
      borderStyle: 'solid',
    },
    '&:disabled:hover': {
      backgroundColor: '#e5e5e5',
      color: 'black',
      border: 'none',
      cursor: 'not-allowed',
    },
  }),
};

function ExpandYearColumn(props) {
  const { expandYearClickHandler, index, disabled } = props;
  const { t } = useTranslation();

  return (
    <button
      disabled={disabled}
      className={[
        props.classes.color,
        'button--primary',
        props.overRideStyle,
      ].join(' ')}
      onClick={() => expandYearClickHandler(index)}
      type="button"
      data-cy="expand-year-button"
      aria-label={t('Expand year {{yearNumber}}', { yearNumber: index + 1 })}
    >
      {t('Expand Year')}
    </button>
  );
}

export default withStyles(buttonStyles)(ExpandYearColumn);
